import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { sessionService } from "@/services/sessionService";

const KEY = ["me", "sessions"] as const;

export function useSessions() {
  return useQuery({ queryKey: KEY, queryFn: sessionService.list });
}

export function useRevokeSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => sessionService.revoke(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useRevokeOtherSessions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => sessionService.revokeOthers(),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
